import { render, staticRenderFns } from "./main.cuentas-bancarias.vue?vue&type=template&id=383762ab"
import script from "./main.cuentas-bancarias.vue?vue&type=script&lang=js"
export * from "./main.cuentas-bancarias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports